import api from "../../../api";
import { getSetting } from "modules/dashboards/actionables/api";

const PRODUCT_DETAILS_JOINS = [
  "product_images",
  "product_icons",
  "product_content",
  "product_content_items",
  "product_content_media",
  "product_usage",
  "product_usage_steps",
  "product_usage_dosage_icons",
  "product_usage_noticeable_changes",
].join(",");

export function fetchAllProducts() {
  return api.get("/product");
}

export function fetchProductDetails(variantId) {
  return api.get("/product-details", {
    params: { variantIds: variantId, joins: PRODUCT_DETAILS_JOINS },
  });
}

export { getSetting as fetchSettingByKey };
